'use strict';

const product = {
    elements: {
        $cartWrapper: $('.js-cart')
    },

    selectors: {
        quantityButton: '.js-quantity-minus, .js-quantity-plus',
        removeButton: '.js-remove-product',
    },

    state: {
        updateQtyUrl: null,
        deleteUrl: null
    },

    callbacks: {
        checkApplePay: null
    },

    init(checkApplePayCallback) {
        this.callbacks.checkApplePay = checkApplePayCallback;
        this.state.updateQtyUrl = this.elements.$cartWrapper.attr('data-cart-update-qty');
        this.state.deleteUrl = this.elements.$cartWrapper.attr('data-cart-delete-item');
        this.initEvent();
    },

    initEvent() {
        this.elements.$cartWrapper.on('click', this.selectors.quantityButton, this.onQuantityButtonClick.bind(this));
        this.elements.$cartWrapper.on('click', this.selectors.removeButton, this.onRemoveButtonClick.bind(this));
    },

    onRemoveButtonClick(e) {
        const $button = $(e.currentTarget);
        const pid = $button.attr('data-pid');
        const uuid = $button.attr('data-uuid');

        $.ajax({
            url: this.state.deleteUrl,
            method: 'GET',
            data: {
                pid: pid,
                uuid: uuid
            },
            success: (data) => {
                this.elements.$cartWrapper.trigger('cart-update', data.basket);
                if (typeof this.callbacks.checkApplePay === 'function') {
                    this.callbacks.checkApplePay();
                }
            }
        });
    },

    onQuantityButtonClick(e) {
        const $button = $(e.currentTarget);
        const pid = $button.attr('data-pid');
        const uuid = $button.closest('.js-cart-product').attr('data-uuid');
        let qty = +$button.attr('data-qty');
        $button.hasClass('js-quantity-minus') ? qty-- : qty++;

        $.ajax({
            url: this.state.updateQtyUrl,
            method: 'GET',
            data: {
                pid: pid,
                quantity: qty,
                uuid: uuid
            },
            success: (data) => {
                this.elements.$cartWrapper.trigger('cart-update', data);
                if (typeof this.callbacks.checkApplePay === 'function') {
                    this.callbacks.checkApplePay();
                }
            }
        });
    }
};

module.exports = {
    init: (callback) => product.init(callback)
};